export { FeatureFlags } from './featureFlagMap';
export const AGREEMENT_APP_PATH = '/LegalAgreement/';
export const INTERSTITIAL_COOKIE_ID = 'InterstitialOffers';

/** Route ID for the account layout route — used by components that access its loader data via useRouteLoaderData */
export const ACCOUNT_LAYOUT_ROUTE_ID = 'routes/my.account.$accountId';

export enum Redirects {
  LZWEBACCOUNTPROFILE = '/LZWeb/MyAccount/AccountProfile.aspx',
  LZWEBAUTHORIZEDCONTACTS = '/LZWeb/MyAccount/AuthorizedContacts.aspx',
  LZWEBPAYMENTMANAGE = '/LZWeb/MyAccount/PaymentManage.aspx',
  LZWEBPAYMENTHISTORY = '/LZWeb/MyAccount/PaymentHistory.aspx',
  LZWEBCOMPLIANCE = '/RACorporateCenter/CompanyDashboard.aspx',
  REXONBOARDING = '/my/onboarding/workspace-selection',
  REXONBOARDINGABBREVIATED = '/my/onboarding/registration-stage',
  REXBOOKSONBOARDING = '/my/books/registration-stage',
  REXCOMPLIANCEONBOARDING = '/my/compliance/registration-stage',
  REXBOOKS = '/my/account/{{accountId}}/books',
  REXCOMPLIANCE = '/my/account/{{accountId}}/compliance',
  ACCOUNT_HOME = '/my/account/{{accountId}}',
  REXVIRTUALMAILONBOARDING = '/my/virtual-mail/workspace-selection',
  REXVIRTUALMAIL = '/my/account/{{accountId}}/virtual-mail',
  REXVIRTUALMAILCHECKOUT = '/my/account/{{accountId}}/virtual-mail/checkout/plan',
  REXCOMPLIANCEWORKSPACESELECTOR = '/my/compliance/workspace-selector',
  REXCOMPLIANCEDOCUMENT = '/my/account/{{accountId}}/compliance?documentId={{documentId}}',
  REXCOMPLIANCEBORONBOARDING = '/my/compliance/beneficial-ownership-report/registration-stage?formationDate',
  REXCOMPLIANCEBORWORKSPACESELECTOR = '/my/compliance/beneficial-ownership-report/workspace-selector',
  REXCOMPLIANCEBORSTANDALONEONBOARDING = '/my/compliance/beneficial-ownership-report/standalone/registration-stage?formationDate',
  REXCOMPLIANCEBORSTANDALONEWORKSPACESELECTOR = '/my/compliance/beneficial-ownership-report/standalone/workspace-selector',
  REXCOMPLIANCEFILINGSONBOARDING = '/my/compliance/beneficial-ownership-report/compliance-filings/registration-stage?formationDate&compliancePackageId=8872',
  REXCOMPLIANCEFILINGSONBOARDINGMAILPROMO = '/my/compliance/beneficial-ownership-report/compliance-filings/registration-stage?formationDate&compliancePackageId=9452',
  REXCOMPLIANCEFILINGSONBOARDINGIQFLOW = '/my/compliance/beneficial-ownership-report/compliance-filings/registration-stage?formationDate',
  REXCOMPLIANCEFILINGSWORKSPACESELECTOR = '/my/compliance/beneficial-ownership-report/compliance-filings/workspace-selector',
  REXCOMPLIANCEFILINGSPLUSONBOARDING = '/my/compliance/beneficial-ownership-report/compliance-filings-plus-licenses/registration-stage?formationDate&compliancePackageId=8879',
  REXCOMPLIANCEFILINGSPLUSONBOARDINGMAILPROMO = '/my/compliance/beneficial-ownership-report/compliance-filings-plus-licenses/registration-stage?formationDate&compliancePackageId=9459',
  REXCOMPLIANCEFILINGSPLUSWORKSPACESELECTOR = '/my/compliance/beneficial-ownership-report/compliance-filings-plus-licenses/workspace-selector',
  REXTAXHOME = '/my/account/{{accountId}}/tax',
  REXDOCUMENTS = '/my/account/{{accountId}}/documents',
  REXTRADEMARK = '/my/account/{{accountId}}/trademark',
  REXLEGAL = '/my/account/{{accountId}}/legal',
  REX_AMENDMENT_WORKSPACE_SELECTOR = '/my/compliance/articles-of-amendment/workspace-selector',
  REX_AMENDMENT_ONBOARDING = '/my/compliance/articles-of-amendment/registration-stage?formationDate',
  REX_INITIAL_REPORTS_WORKSPACE_SELECTOR = '/my/compliance/initial-reports/workspace-selector',
  REX_INITIAL_REPORTS_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyInitialReports',
  REX_EIN_WORKSPACE_SELECTOR = '/my/compliance/ein/workspace-selector',
  REX_ANNUAL_REPORTS_WORKSPACE_SELECTOR = '/my/compliance/annual-reports/workspace-selector',
  REX_PARTNER_COLUMN_TAX = '/my/account/{{accountId}}/tax/column-tax',
  IQ_ANNUAL_REPORTS_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyAnnualReports',
  IQ_EIN_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyEIN',
  REX_RA_WORKSPACE_SELECTOR = '/my/compliance/registered-agent/workspace-selector',
  IQ_RA_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyRegisteredAgent',
  IQ_BOIR_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyBOIR',
  IQ_AMENDMENT_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyComplianceArticles',
  IQ_COMPLIANCE_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyCompliance',
  IQ_COMPLIANCE_RESUMPTION = '/hft/gtky/entity-type?graphType=gtkyComplianceFilings',
  IQ_VIRTUALMAIL_ONBOARDING = '/hft/gtky/workspace-selection?graphType=gtkyVirtualMail',
  REX_DISSOLUTION_WORKSPACE_SELECTOR = '/my/compliance/dissolution/workspace-selector',
  IQ_DISSOLUTION_ONBOARDING = '/hft/gtky/registration-stage?graphType=gtkyDissolution',
}

export enum Monitor {
  VERSION = 'my/version',
  HEALTH = 'my/health',
}

export enum LoginUX {
  LOGIN = 'my/login',
}

export enum LinkType {
  ContactUs = 'contactUs',
}
// An "indexable" route is a uri that we want properly indexed by google.
export const IndexableRoutes = {
  login: '/my/login',
  docAssist: '/ai/doc-assist',
  templates: '/templates',
} as const;

export const IndexablePrefixes = {
  templates: '/templates/',
} as const;

// A "public" route is a uri that does not require authentication. Public
// routes will not trigger auth code and will therefore not have access to any
// user data. Includes indexable routes.
export const PublicRoutes = {
  aiDocSummarizer: '/ai/',
  checkout: '/my/checkout',
  checkoutPay: '/my/checkout/pay',
  checkoutPurchaseTest: '/my/checkout/purchaseTest',
  checkoutReview: '/my/checkout/review',
  checkoutConfirmation: '/my/checkout/confirmation',
  createAccount: '/my/create-account',
  eSignature: '/my/e-signature',
  formsBuilder: '/forms-builder',
  logout: '/my/logout',
  view: '/view',
  viewInvoice: '/view-invoice',
  viewProposal: '/view-proposal',
  complianceHealthScan: '/business-compliance-check',
  signatureCapture: '/my/signature-capture',
  ...IndexableRoutes,
} as const;

// A "base" route is valid root path (defined at the top level of apps/my-account/app/routes).
export const BaseRoutes = {
  My: '/my',
  AI: '/ai',
  Templates: '/templates',
  View: '/view',
  ViewInvoice: '/view-invoice',
  ViewProposal: '/view-proposal',
  ComplianceHealthScan: '/business-compliance-check',
} as const;

export type BaseRoutesType = (typeof BaseRoutes)[keyof typeof BaseRoutes];

export const GoogleFontsUrls = {
  WorkSans:
    'https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600&display=swap',
} as const;

export enum SubscriptionsActions {
  GET_SUBSCRIPTIONS = 'get_subscriptions',
  CANCEL_SUBSCRIPTION = 'cancel_subscription',
  UPDATE_SUBSCRIPTION = 'update_subscription',
  GET_SUBSCRIPTION_PAYMENTS = 'get_subscription_payments',
  UPDATE_SUBSCRIPTION_WITH_PAYMENT_PROFILE = 'update_subscription_with_payment_profile',
  GET_PAYMENT_AUTHORIZATION_STATUS = 'get_payment_authorization_status',
  UNCANCEL_SUBSCRIPTION = 'uncancel_subscription',
  UNCANCEL_SUBSCRIPTION_WITH_PAYMENT_PROFILE = 'uncancel_subscription_with_payment_profile',
}

export enum PaymentStatus {
  Pending = 1,
  Approved = 2,
  Declined = 3,
  Cancelled = 4,
  Uncollectible = 5,
}

export enum InstallmentActions {
  UPDATE_INSTALLMENT = 'update-installment',
  UPDATE_INSTALLMENT_NEW_PAYMENT_PROFILE = 'update-installment-new-payment-profile',
  UPDATE_MULTIPLE_INSTALLMENTS = 'update-multiple-installments',
}

export enum InstallmentBillStatus {
  NotYetDue = 1,
  PaymentDue = 2,
  Paid = 3,
  PastDueWillReharvest = 4,
  PastDueWontReharvest = 5,
  Error = 6,
  Uncollectible = 9,
}

export const SESSION_REFRESH_PATH = '/my/api/session/refresh';
